<template lang="pug">
#GarantiaReparacion
  b-button(
    variant="action"
    @click="openModal"
    :disabled="disabled"
  )
    | Garantía de Reparación
    b-spinner(v-if="loading" small)

  //- Modal de Garantía siguiendo diseño pixel perfect de Figma (1680:1864)
  b-modal#modal-garantia(
    v-model="showModal"
    no-close-on-backdrop
    hide-footer
    centered
    size="md"
  )
    template(#modal-header="{ close }")
      .modal-custom-header
        .header-title
          span.title-main Solicitud de Excepción:
          span.title-sub Garantía de Reparación
        b-icon.close-icon(icon="x" @click="close")

    .modal-custom-body
      p.description
        | Al solicitar esta excepción, se aplicará un descuento total (100%) sobre el valor de la cotización actual para la siguiente OV:

      .ov-info-box
        p OV: {{ dataOv.id }} | Cliente: {{ nombreCliente }}

      .form-group-custom
        label.label-bold Motivo de la Solicitud de Garantía (Obligatorio)
        b-form-textarea.custom-textarea(
          v-model="comentario"
          placeholder="Describe detalladamente el antecedente técnico o la falla que justifica la aplicación de garantía al 100% sobre esta cotización..."
          rows="4"
          :state="comentarioValido"
        )
        b-form-invalid-feedback(v-if="!comentarioValido")
          | El motivo es obligatorio para solicitar la garantía.

      .modal-custom-footer
        b-button.btn-secundary(@click="showModal = false") Cancelar
        b-button.btn-primary(@click="enviarSolicitud" :disabled="loading")
          | Solicitar Excepción
          b-spinner(v-if="loading" small)
</template>

<script>
import { mapActions } from 'vuex'
import { TIPO_EXCEPCION } from '@/utils/enums/exceptions'

export default {
  name: 'GarantiaReparacion',
  props: {
    dataOv: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: false,
      loading: false,
      comentario: '',
      submitted: false,
    }
  },
  computed: {
    nombreCliente() {
      if (this.dataOv.cliente) {
        if (
          this.dataOv.cliente.tipo_cliente === 'persona' &&
          this.dataOv.cliente.persona
        ) {
          return `${this.dataOv.cliente.persona.nombre} ${this.dataOv.cliente.persona.apellido}`
        }
        if (
          this.dataOv.cliente.tipo_cliente === 'empresa' &&
          this.dataOv.cliente.empresa
        ) {
          return this.dataOv.cliente.empresa.razon_social
        }
      }
      return this.dataOv.nombre || 'N/A'
    },
    comentarioValido() {
      if (!this.submitted) return null
      return this.comentario.trim().length > 0
    },
  },
  methods: {
    ...mapActions('OVStore', ['crearExcepcion']),
    openModal() {
      this.comentario = ''
      this.submitted = false
      this.showModal = true
    },
    async enviarSolicitud() {
      this.submitted = true
      if (!this.comentario.trim()) return

      this.loading = true
      try {
        await this.crearExcepcion({
          id_oportunidad_venta: this.dataOv.id,
          comentario: this.comentario,
          tipo: TIPO_EXCEPCION.GARANTIA_REPARACION,
        })

        this.$bvToast.toast('Solicitud de garantía enviada correctamente', {
          title: 'Éxito',
          variant: 'success',
          solid: true,
        })

        this.$emit('reloadAll')
        this.showModal = false
      } catch (error) {
        console.error(error)
        this.$bvToast.toast(
          error.response?.data?.mensaje || 'Error al enviar la solicitud',
          {
            title: 'Error',
            variant: 'danger',
            solid: true,
          }
        )
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-custom-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  padding: 0;

  .header-title {
    display: flex;
    flex-direction: column;
    color: #23201c;
    font-family: 'Noto Sans', sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: normal;

    .title-main {
      display: block;
    }
  }

  .close-icon {
    font-size: 24px;
    cursor: pointer;
    color: #23201c;
  }
}

.modal-custom-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0;

  .description {
    color: #525252;
    font-family: 'Noto Sans', sans-serif;
    font-size: 15px;
    font-weight: 400;
    margin: 0;
  }

  .ov-info-box {
    background-color: #dddde1;
    border-radius: 5px;
    padding: 10px;

    p {
      color: #525252;
      font-family: 'Noto Sans', sans-serif;
      font-size: 15px;
      font-weight: 400;
      margin: 0;
    }
  }

  .form-group-custom {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .label-bold {
      color: #23201c;
      font-family: 'Noto Sans', sans-serif;
      font-size: 15px;
      font-weight: 700;
      margin: 0;
    }

    .custom-textarea {
      border: 1px solid #525252;
      border-radius: 5px;
      padding: 10px;
      font-family: 'Noto Sans', sans-serif;
      font-size: 15px;
      color: #525252;

      &::placeholder {
        color: #525252;
        opacity: 0.6;
      }
    }
  }
}

.modal-custom-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;

  .btn-secundary {
    background-color: #f5f6fa;
    border: none;
    border-radius: 8px;
    color: #23201c;
    font-family: 'Noto Sans', sans-serif;
    font-size: 15px;
    font-weight: 500;
    height: 45px;
    padding: 0 20px;

    &:hover {
      background-color: darken(#f5f6fa, 5%);
    }
  }

  .btn-primary {
    background-color: #fece2f;
    border: none;
    border-radius: 8px;
    color: #23201c;
    font-family: 'Noto Sans', sans-serif;
    font-size: 15px;
    font-weight: 500;
    height: 45px;
    padding: 0 20px;

    &:hover {
      background-color: darken(#fece2f, 5%);
    }
  }
}

// Estilos globales dentro del modal para sobreescribir Bootstrap Vue si es necesario
::v-deep .modal-header {
  border-bottom: none;
  padding: 20px 20px 10px 20px;
}

::v-deep .modal-body {
  padding: 0 20px 20px 20px !important;
}
</style>
